export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1e3,
    lg: 1200,
    xl: 1920,
  },
};
